import { useEffect, useState } from "react";
import {
  LS_RECENT_FILTERS,
  RECENT_LIST_SIZE,
} from "../../Findings/FindingsFilters/FilterUtils";

interface UseRecentFiltersReturn {
  recentFilters: string[];
  addFilterToRecent: (filterData: string) => void;
  removeFilterFromRecent: (filterId: string) => void;
}

const useRecentFilters = (): UseRecentFiltersReturn => {
  const [recentFilters, setRecentFilters] = useState<string[]>([]);
  useEffect(() => {
    setRecentFilters(
      JSON?.parse(localStorage.getItem(LS_RECENT_FILTERS) ?? "null") || []
    );
  }, []);

  const addFilterToRecent = (filterData: string): void => {
    const currentRecentFiltersList = [...recentFilters];
    if (!currentRecentFiltersList?.includes(filterData)) {
      currentRecentFiltersList?.unshift(filterData);

      if (currentRecentFiltersList?.length > RECENT_LIST_SIZE) {
        currentRecentFiltersList.splice(
          RECENT_LIST_SIZE,
          currentRecentFiltersList?.length - RECENT_LIST_SIZE
        );
      }

      localStorage.setItem(
        LS_RECENT_FILTERS,
        JSON.stringify(currentRecentFiltersList)
      );

      setRecentFilters(currentRecentFiltersList);
    }
  };

  const removeFilterFromRecent = (filterId: string): void => {
    const currentRecentFiltersList = [...recentFilters];
    const filterIndex = currentRecentFiltersList.findIndex(
      (filter) => filter === filterId
    );
    // Preserve the original JS coercing comparison exactly: `string >= 0`
    // coerces filterId to a number (NaN for non-numeric ids), so the branch is
    // taken only for numeric-string ids. The cast is erased at runtime, leaving
    // the `>=` operator's own coercion unchanged.
    if ((filterId as unknown as number) >= 0) {
      currentRecentFiltersList.splice(filterIndex, 1);

      localStorage.setItem(
        LS_RECENT_FILTERS,
        JSON.stringify(currentRecentFiltersList)
      );

      setRecentFilters(currentRecentFiltersList);
    }
  };

  return {
    recentFilters,
    addFilterToRecent,
    removeFilterFromRecent,
  };
};

export default useRecentFilters;
